import { memo, type FC } from 'react';

import { useDeliveryMeta } from '@/productDiscovery/ProductPage/common/modules/Delivery/delivery.ducks';

import { useProductBundle } from '../../../../context/ProductBundle/ProductBundle.context';
import {
  outlineBundleHeaderTitle,
  outlineBundleHeaderTitleFreeDelivery,
  outlineBundleHeaderTitleMF,
  outlineBundleHeaderTitleSameSeller,
} from './OutlineBundleHeader.translations';
import OutlineBundleHeaderTitleSkel from './OutlineBundleHeaderTitle/OutlineBundleHeaderTitleSkel';

import styles from './outlineBundleHeader.module.scss';

const OutlineBundleHeader: FC = memo(() => {
  const meta = useDeliveryMeta();
  const { productList, state } = useProductBundle();

  if (state.isFetching) {
    return <OutlineBundleHeaderTitleSkel />;
  }

  const getDynamicTitle = () => {
    const isMmf = productList.every((product) => product?.isMmf);
    const hasFreeDelivery = productList
      .slice(1)
      .every((product) => product?.hasFreeDelivery); // Here we are checking if all the complementary products have free delivery

    const sameSeller = productList.every(
      (product, i, arr) =>
        i === 0 || product?.sellerId === arr[i - 1]?.sellerId,
    );

    if (isMmf) {
      return outlineBundleHeaderTitleMF;
    }
    if (meta.hasFreeDelivery && hasFreeDelivery) {
      return outlineBundleHeaderTitleFreeDelivery;
    }
    if (sameSeller) {
      return outlineBundleHeaderTitleSameSeller;
    }

    return outlineBundleHeaderTitle;
  };

  const title = getDynamicTitle();

  return (
    <header className={styles.wrapper}>
      <div className={styles.header} data-testid="outline-bundle-header">
        {title}
      </div>
    </header>
  );
});

OutlineBundleHeader.displayName = 'OutlineBundleHeader';

export default OutlineBundleHeader;
